// import React from 'react';
// import Slider from "react-slick";
// import iimg2 from '../img/banner/bike.jpg'
// import iimg3 from '../img/banner/bedroom-5664221_1280.jpg'
// import iimg4 from '../img/aaaservices/ba1.webp';
// import iimg1 from '../img/banner/BANQETHALL.jpeg';
// import iimg5 from '../img/banner/TRAVLES3.jpg'
// import iimg6 from '../img/banner/TRAVLES2.jpg';
// // import Commercial7 from '../img/banner/Commercial7.png';
// import "slick-carousel/slick/slick.css"; 
// import "slick-carousel/slick/slick-theme.css";
// import { Link } from 'react-router-dom';

// const Services = () => {
//   // Slick slider settings
//   const settings = {
//     dots: false,
//     infinite: true,
//     speed: 300,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//      autoplay: true,
//       autoplaySpeed: 1000,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 1,
//           infinite: true,
//           dots: true
//         }
//       },
//       {
//         breakpoint: 900,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           infinite: true,
//           dots: false,
//         }
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           dots: false,
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           dots: false,
//         }
//       }
//       // You can unslick at a given breakpoint now by adding:
//       // settings: "unslick"
//       // instead of a settings object
//     ]
//   };

//   return (
//     <section className="services-boxes-area" style={{ backgroundColor: '#e6eeef' }}>
//       <div className="">
//         <Slider {...settings}>
//           {/* <div className="single-box">
//             <img src={iimg2} alt="Residential Interiors" />
//             <div className="contents">
//               <h3>
//                 <Link to="/it-services">Bike  </Link>
//               </h3>
//             </div>
//             <div className="hover-content">
//               <h3>
//                 <Link to="/it-services">Bike </Link>
//               </h3>
//               <p><span style={{fontFamily: 'Raqupine Regular' }}> TRAVLES </span> Streamline your delivery operations with  Delivery Bike Services. Whether you're a business needing reliable delivery solutions or an individual requiring on-demand courier services, we offer:.</p>
//               <Link to="/it-services" className="read-more-btn">Learn More</Link>
//             </div>
//           </div> */}

//           <div className="single-box">
//             <img src={iimg3} alt="Commercial Interiors" />
//             <div className="contents">
//               <h3>
//                 <Link to="/gaming"> Rooms </Link>
//               </h3>
//             </div>
//             <div className="hover-content">
//               <h3>
//                 <Link to="/gaming">Rooms </Link>
//               </h3>
//               <p><span style={{fontFamily: 'Raqupine Regular' }}> TRAVLES </span>   Car Services offer comprehensive solutions for all your vehicle needs, ensuring convenience, reliability, and quality</p>
//               <Link to="/gaming" className="read-more-btn">Learn More</Link>
//             </div>
//           </div>

//           <div className="single-box">
//             <img src={iimg4} alt="/what-we-do" />
//             <div className="contents">
//               <h3>
//                 <Link to="/gaming">  Banquet Hall</Link>
//               </h3>
//             </div>
//             <div className="hover-content">
//               <h3>
//                 <Link to="/gaming"> Banquet Hall </Link>
//               </h3>
//               <p>Road transportaion Services ensure your heavy-duty vehicles stay in top condition for the long haul. We provide reliable, efficient, and specialized services for trucks of all sizes.</p>
//               <Link to="/gaming" className="read-more-btn">Learn More</Link>
//             </div>
//           </div>

//           <div className="single-box">
//             <img src={iimg1} alt="Showcase Interiors" />
//             <div className="contents">
//               <h3>
//                 <Link to="/gaming">Restaurant</Link>
//               </h3>
//             </div>
//             <div className="hover-content">
//               <h3>
//                 <Link to="/gaming">Restaurant</Link>
//               </h3>
//               <p>Import and Export Services are tailored to keep your passenger vehicles running safely and efficiently. Whether for public transportation, school buses, or private charters, we provide comprehensive care to meet your needs. <span style={{fontFamily: 'Raqupine Regular' }}> TRAVLES </span> </p>
//               <Link to="/gaming" className="read-more-btn">Learn More</Link>
//             </div>
//           </div>


         
//         </Slider>
//       </div>
//     </section>
//   );
// };

// export default Services;









import React, { useState } from "react";
import { motion } from "framer-motion";
import aboutUsImage from "../img/banner/Frame 7 (2).png"; // Import the image

const AboutUs = () => {
  const [showMore, setShowMore] = useState(false);

  const handleToggleText = () => {
    setShowMore(!showMore);
  };

  return (
    <section id="who-we-are" style={{ paddingTop: "100px", marginTop: "-80px" }}>
      <section 
        className="about-area ptb-100"
        style={{ 
          padding: "27px 0",
        }}
      >
        <div  style={{textAlign:"center",marginTop:'-68px'}}> 
        <h1 
                style={{ 
                  fontSize: "42px", 
                  fontFamily: "Lato, sans-serif", 
                  position: "relative", 
                  display: "inline-block",
                  color: "#ffbb60"
                }}
              >
                About <span style={{ color: "#4b0100" }}>Us</span>
                <span
                  style={{
                    position: "absolute",
                    bottom: "-8px",
                    left: "0",
                    width: "50%",
                    height: "2px",
                    backgroundColor: "#000",
                  }}
                />
              </h1>
        </div>
        <div className="container">
          <div 
            className="row align-items-center"
            style={{ display: "flex", flexWrap: "wrap", marginTop: "34px" }}
          >

            {/* Left Side: About Content (Text) */}
            <motion.div
              className="col-lg-6 col-md-12"
              initial={{ x: "-100vw", opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 1, ease: "easeOut" }}
              style={{
                textAlign: "left",
                maxWidth: "600px", // Control text width
              }}
              whileHover={{
                y: -10, // Text will move slightly up when hovered
                transition: { duration: 0.3 }
              }}
            >
              

              <p style={{ fontSize: "16px", textAlign: "left", lineHeight: "1.8", color: "black" }}>
                Welcome to{" "}
                <span style={{ fontFamily: "Raqupine Regular", color: "black" }}></span>, 
                At Sharan’s Inn, we redefine hospitality with a perfect blend of comfort, convenience, and 
                elegance. Strategically located for both leisure and business travellers, Sharan’s Inn offers a 
                welcoming atmosphere, thoughtfully designed rooms, versatile banquet spaces, and an 
                exceptional dining experience all under one roof. 
                Our well-appointed rooms provide a peaceful retreat with modern amenities to ensure a 
                relaxing stay. Whether you're visiting for a short trip or an extended stay,
                you....
              </p>

              {/* Conditionally Render Additional Text with Slide Effect */}
              <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: showMore ? 1 : 0, y: showMore ? 0 : -20 }}
                transition={{ duration: 0.5 }}
                style={{ marginTop: "20px" }}
              >
                {showMore && (
                  <p style={{ fontSize: "16px", textAlign: "left", lineHeight: "1.8", color: "black" }}>
                    we promise a restful 
                    and memorable experience. 
                    With spacious banquet halls equipped to host everything from intimate gatherings to grand 
                    celebrations, Sharan’s Inn is the ideal venue for weddings, corporate events, parties, and 
                    conferences. Our dedicated event team works closely with you to turn every occasion into a 
                    seamless success. 
                    Our in-house restaurants offer a delightful culinary journey, serving a variety of cuisines 
                    prepared with the freshest ingredients and a passion for flavour. Whether it’s a casual meal, a 
                    family dinner, or a business lunch, we provide the perfect setting. 
                    At Sharan’s Inn, we don’t just provide a place to stay- we create experiences that stay with 
                  </p>
                )}
              </motion.div>

              {/* Show More Button */}
              <button 
                onClick={handleToggleText}
                style={{
                  backgroundColor: "rgb(131 42 42)",
                  border: "none",
                  color: "white",
                  padding: "10px 20px",
                  cursor: "pointer",
                  borderRadius: "5px",
                  fontSize: "16px"
                }}
              >
                {showMore ? "Show Less" : "Show More"}
              </button>

            </motion.div>

            {/* Right Side: About Image */}
            <div
              className="col-lg-6 col-md-12 text-center"
              initial={{ x: "100vw", opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 1, ease: "easeOut" }}
              whileHover={{
                x: 10, // Image moves slightly to the right when hovered
                transition: { duration: 0.3 }
              }}
            >
              <div>
                <img
                  src={aboutUsImage}
                  alt="About Us"
                  className="img-fluid"
                  style={{
                    maxWidth: "100%", 
                    height: "334px",
                    borderRadius: "10px",
                    display: "block",
                    marginLeft: "auto", 
                    marginTop:'10px' // Align image to right side
                  }}
                />
              </div>
            </div>

          </div>
        </div>
      </section>
    </section>
  );
};

export default AboutUs;



